import React, { Component } from 'react';
import { Menu } from '../../components/Menu/Menu';
import LoadingWindow from '../../components/LoadingWindow';
import { confirmCloseAlert } from '../../functions/alerts';
import { listVendors, getNextVendorNo, saveVendor, deactivateVendor } from '../../services/maintenanceService';
import Swal from 'sweetalert2';
import { TbTruck, TbBuildingWarehouse } from 'react-icons/tb';
import { AiOutlineSearch, AiOutlineSave } from 'react-icons/ai';
import { BsPlusCircle, BsPencilSquare, BsSlashCircle, BsXCircle } from 'react-icons/bs';
import { IoCloseCircle } from 'react-icons/io5';
import styles from '../../css/Vendors.module.css';

// Devuelve el primer valor no nulo/indefinido (reemplazo de `??`).
function val() {
    for (let i = 0; i < arguments.length; i++) {
        if (arguments[i] !== undefined && arguments[i] !== null) return arguments[i];
    }
    return undefined;
}
const isBlank = (x) => String(x === undefined || x === null ? '' : x).trim() === '';

// ─── Teléfono US ──────────────────────────────────────────────────────────────
// Deja solo dígitos y quita el "1" de país si viene incluido (máx. 10 dígitos).
export function phoneDigits(value) {
    let d = String(value === undefined || value === null ? '' : value).replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return d.slice(0, 10);
}
// Formatea progresivamente como +1 (XXX) XXX-XXXX (siempre lada USA).
export function formatPhone(value) {
    const d = phoneDigits(value);
    if (!d) return '';
    const a = d.slice(0, 3);
    const b = d.slice(3, 6);
    const c = d.slice(6, 10);
    let out = '+1 (' + a;
    if (d.length >= 3) out += ')';
    if (b) out += ' ' + b;
    if (c) out += '-' + c;
    return out;
}

// ─── Modelo ───────────────────────────────────────────────────────────────────
// Nombres de campo MAS90; normaliza también los camelCase que pueda dar el backend.
export class Vendor {
    constructor(v = {}) {
        this.VendorNo = val(v.VendorNo, v.vendorNo, v.customerNo, '');
        this.VendorName = val(v.VendorName, v.name, '');
        this.AddressLine1 = val(v.AddressLine1, v.addressLine1, '');
        this.City = val(v.City, v.city, '');
        this.State = val(v.State, v.state, '');
        this.ZipCode = val(v.ZipCode, v.zipCode, '');
        this.TelephoneNo = formatPhone(val(v.TelephoneNo, v.telephoneNo, v.phone1, ''));
        this.EmailAddress = val(v.EmailAddress, v.emailAddress, '');
        this.active = val(v.active, v.Active, 1) ? 1 : 0;
    }
}

export function emptyVendorForm() {
    return { VendorNo: '', VendorName: '', AddressLine1: '', City: '', State: '', ZipCode: '', TelephoneNo: '', EmailAddress: '' };
}

// Validación: sin campos vacíos, email válido, teléfono US de 10 dígitos.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function validateVendor(f) {
    const e = {};
    if (isBlank(f.VendorName)) e.VendorName = 'Required';
    if (isBlank(f.AddressLine1)) e.AddressLine1 = 'Required';
    if (isBlank(f.City)) e.City = 'Required';
    if (isBlank(f.State)) e.State = 'Required';
    if (isBlank(f.ZipCode)) e.ZipCode = 'Required';
    if (isBlank(f.TelephoneNo)) e.TelephoneNo = 'Required';
    else if (phoneDigits(f.TelephoneNo).length !== 10) e.TelephoneNo = 'Enter a valid 10-digit US number';
    if (isBlank(f.EmailAddress)) e.EmailAddress = 'Required';
    else if (!EMAIL_RE.test(String(f.EmailAddress).trim())) e.EmailAddress = 'Invalid email';
    return e;
}

const FIELDS = [
    { id: 'VendorName', label: 'Vendor Name', col: 'col-12' },
    { id: 'AddressLine1', label: 'Address Line 1', col: 'col-12' },
    { id: 'City', label: 'City', col: 'col-6' },
    { id: 'State', label: 'State', col: 'col-3' },
    { id: 'ZipCode', label: 'Zip Code', col: 'col-3' },
    { id: 'TelephoneNo', label: 'Telephone No', col: 'col-6', type: 'tel', kind: 'phone', placeholder: '+1 (555) 123-4567' },
    { id: 'EmailAddress', label: 'Email Address', col: 'col-6', type: 'email' },
];

export default class Vendors extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
        this.state = {
            all: [],
            search: '',
            selected: null,
            showModal: false,
            isEdit: false,
            form: emptyVendorForm(),
            errors: {},
            saving: false,
        };
    }

    componentDidMount() { this.load(); }

    async load() {
        this.ModalLoading.current.showState(true);
        const data = await listVendors();
        this.ModalLoading.current.showState(false);
        const all = (data || []).map(v => new Vendor(v));
        this.setState({ all });
    }

    openCreate = async () => {
        this.ModalLoading.current.showState(true);
        const nextNo = await getNextVendorNo();   // último registro + 1 (backend)
        this.ModalLoading.current.showState(false);
        this.setState({
            showModal: true, isEdit: false, errors: {},
            form: { ...emptyVendorForm(), VendorNo: val(nextNo, '') },
        });
    };

    openEdit = (v) => {
        this.setState({ showModal: true, isEdit: true, errors: {}, form: { ...v } });
    };

    closeModal = () => this.setState({ showModal: false });

    onField = (id, value) => {
        this.setState(prev => ({
            form: { ...prev.form, [id]: value },
            errors: { ...prev.errors, [id]: undefined },
        }));
    };

    submit = async () => {
        const { form, isEdit } = this.state;
        const errors = validateVendor(form);
        if (Object.keys(errors).length > 0) { this.setState({ errors }); return; }

        // Al backend van los dígitos crudos; el formato +1 (...) es solo estético en el frontend.
        const payload = { ...form, TelephoneNo: phoneDigits(form.TelephoneNo) };
        this.setState({ saving: true });
        const okSave = await saveVendor(payload, isEdit);
        this.setState({ saving: false });
        if (okSave) {
            confirmCloseAlert('correct', `Vendor ${isEdit ? 'updated' : 'created'} successfully.`);
            this.setState({ showModal: false });
            this.load();
            if (isEdit) this.setState({ selected: new Vendor(form) });
        } else {
            confirmCloseAlert('incorrect', `Could not ${isEdit ? 'update' : 'create'} the vendor. Please try again.`);
        }
    };

    confirmDeactivate = (v) => {
        Swal.fire({
            title: 'Deactivate vendor?',
            html: `<b>${v.VendorName}</b> (${v.VendorNo}) will be marked inactive.`,
            icon: 'warning', showCancelButton: true,
            confirmButtonColor: '#EF4444', cancelButtonColor: '#64748B',
            confirmButtonText: 'Yes, deactivate', cancelButtonText: 'Cancel',
        }).then(async (r) => {
            if (!r.isConfirmed) return;
            this.ModalLoading.current.showState(true);
            const okDe = await deactivateVendor(v.VendorNo);
            this.ModalLoading.current.showState(false);
            if (okDe) {
                confirmCloseAlert('correct', 'Vendor deactivated.');
                this.setState({ selected: null });
                this.load();
            } else {
                confirmCloseAlert('incorrect', 'Could not deactivate the vendor.');
            }
        });
    };

    render() {
        const { all, search, selected, showModal, isEdit, form, errors, saving } = this.state;
        const q = search.toLowerCase();
        const filtered = all.filter(v => !q || (`${v.VendorName} ${v.VendorNo} ${v.City}`).toLowerCase().includes(q));

        return (
            <div className={styles.page}>
                <Menu />
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div className={styles.hero}>
                    <div className={styles.heroLeft}>
                        <div className={styles.heroIconBox}>
                            <TbTruck className={styles.heroIcon} />
                        </div>
                        <div>
                            <h1 className={styles.heroTitle}>Vendors</h1>
                            <p className={styles.heroSubtitle}>{all.length} vendors · Create and maintain vendor master records</p>
                        </div>
                    </div>
                    <button className={styles.heroBtn} onClick={this.openCreate}>
                        <BsPlusCircle /> New Vendor
                    </button>
                </div>

                <div className={styles.body}>
                    {/* LEFT — lista */}
                    <div className={styles.listPanel}>
                        <div className={styles.searchWrap}>
                            <div className={styles.searchBox}>
                                <AiOutlineSearch className={styles.searchIcon} />
                                <input
                                    className={styles.searchInput}
                                    type="text"
                                    placeholder="Search vendors..."
                                    value={search}
                                    onChange={e => this.setState({ search: e.target.value })}
                                />
                                {search && (
                                    <IoCloseCircle className={styles.searchClear} title="Clear search" onClick={() => this.setState({ search: '' })} />
                                )}
                            </div>
                        </div>
                        <div className={styles.list}>
                            {filtered.length === 0 && <div className={styles.emptyRow}>No vendors found</div>}
                            {filtered.map((v, i) => {
                                const isSel = selected && selected.VendorNo === v.VendorNo;
                                return (
                                    <div key={i} onClick={() => this.setState({ selected: v })}
                                        className={`${styles.item} ${isSel ? styles.itemActive : ''}`}>
                                        <div className={styles.itemAvatar}><TbBuildingWarehouse /></div>
                                        <div className={styles.itemInfo}>
                                            <div className={styles.itemName}>{v.VendorName}</div>
                                            <div className={styles.itemSub}>{v.VendorNo}{v.City ? ` · ${v.City}` : ''}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* RIGHT — detalle (show) */}
                    <div className={styles.detail}>
                        {!selected ? (
                            <div className={styles.emptyState}>
                                <TbTruck className={styles.emptyIcon} />
                                <p className={styles.emptyText}>Select a vendor from the list</p>
                            </div>
                        ) : (
                            <>
                                <div className={styles.detailHeader}>
                                    <div className={styles.detailAvatar}><TbBuildingWarehouse /></div>
                                    <div className={styles.detailHeaderInfo}>
                                        <div className={styles.detailTitle}>{selected.VendorName}</div>
                                        <span className={styles.badge}>{selected.VendorNo}</span>
                                    </div>
                                    <div className={styles.detailActions}>
                                        <button className={styles.btnPrimary} onClick={() => this.openEdit(selected)}><BsPencilSquare /> Edit</button>
                                        <button className={styles.btnDanger} onClick={() => this.confirmDeactivate(selected)}><BsSlashCircle /> Deactivate</button>
                                    </div>
                                </div>

                                <div className={styles.card}>
                                    <div className={styles.cardHeader}>
                                        <span className={styles.cardHeaderTitle}>Vendor Information</span>
                                    </div>
                                    <div className={styles.cardBody}>
                                        <div className="row g-3">
                                            {[
                                                ['Vendor No', selected.VendorNo], ['Vendor Name', selected.VendorName],
                                                ['Address Line 1', selected.AddressLine1], ['City', selected.City],
                                                ['State', selected.State], ['Zip Code', selected.ZipCode],
                                                ['Telephone No', selected.TelephoneNo], ['Email Address', selected.EmailAddress],
                                            ].map(([k, value], i) => (
                                                <div key={i} className="col-12 col-md-6">
                                                    <label className={styles.fieldLabel}>{k}</label>
                                                    <div className={styles.fieldValue}>{value || <span className={styles.fieldValueEmpty}>—</span>}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* Modal crear/editar (insert / edit) */}
                {showModal && (
                    <div className={styles.modalOverlay}>
                        <div className={styles.modal}>
                            <div className={styles.modalHeader}>
                                <div>
                                    <div className={styles.modalTitle}>{isEdit ? 'Edit Vendor' : 'Create New Vendor'}</div>
                                    <div className={styles.modalSubtitle}>Vendor No is assigned by the system and cannot be edited</div>
                                </div>
                                <button className={styles.modalClose} onClick={this.closeModal}><BsXCircle /></button>
                            </div>
                            <div className={styles.modalBody}>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <label className={styles.formLabel}>Vendor No (system)</label>
                                        <input id="VendorNo" className={`${styles.input} ${styles.inputDisabled}`} value={form.VendorNo || ''} disabled placeholder="Assigned by the system" />
                                    </div>
                                    {FIELDS.map(f => (
                                        <div key={f.id} className={f.col}>
                                            <label className={styles.formLabel} htmlFor={f.id}>{f.label}<span className={styles.required}> *</span></label>
                                            <input
                                                id={f.id}
                                                type={f.type || 'text'}
                                                inputMode={f.kind === 'phone' ? 'tel' : undefined}
                                                placeholder={f.placeholder}
                                                className={`${styles.input} ${errors[f.id] ? styles.inputError : ''}`}
                                                value={form[f.id] || ''}
                                                onChange={e => this.onField(f.id, f.kind === 'phone' ? formatPhone(e.target.value) : e.target.value)}
                                            />
                                            {errors[f.id] && <div className={styles.formError}>{errors[f.id]}</div>}
                                        </div>
                                    ))}
                                </div>
                                <div className={styles.modalActions}>
                                    <button className={styles.btnCancel} onClick={this.closeModal}><BsXCircle /> Cancel</button>
                                    <button className={styles.btnSubmit} onClick={this.submit} disabled={saving}>
                                        {isEdit ? <><AiOutlineSave /> Save Changes</> : <><BsPlusCircle /> Create Vendor</>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
